// Generated by purs version 0.15.16
import * as API_Document from "../API.Document/index.js";
import * as API_Pagination from "../API.Pagination/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_Step1_State from "../Steps.Step1.State/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_UpdateForm from "../Widgets.UpdateForm/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(/* #__PURE__ */ Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean));
var find = /* #__PURE__ */ Data_Foldable.find(Data_Foldable.foldableArray);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var map1 = /* #__PURE__ */ Data_Functor.map(API_Pagination.functorPage);
var fromFoldable$prime = /* #__PURE__ */ Internal_SelectionMap["fromFoldable$prime"](/* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString))(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var UpdateSemester = /* #__PURE__ */ (function () {
    function UpdateSemester() {

    };
    UpdateSemester.value = new UpdateSemester();
    return UpdateSemester;
})();
var UpdateTeacher = /* #__PURE__ */ (function () {
    function UpdateTeacher() {

    };
    UpdateTeacher.value = new UpdateTeacher();
    return UpdateTeacher;
})();
var UpdateSemesterSelected = /* #__PURE__ */ (function () {
    function UpdateSemesterSelected(value0) {
        this.value0 = value0;
    };
    UpdateSemesterSelected.create = function (value0) {
        return new UpdateSemesterSelected(value0);
    };
    return UpdateSemesterSelected;
})();
var UpdateTeacherSelected = /* #__PURE__ */ (function () {
    function UpdateTeacherSelected(value0) {
        this.value0 = value0;
    };
    UpdateTeacherSelected.create = function (value0) {
        return new UpdateTeacherSelected(value0);
    };
    return UpdateTeacherSelected;
})();
var EditDocument = /* #__PURE__ */ (function () {
    function EditDocument(value0) {
        this.value0 = value0;
    };
    EditDocument.create = function (value0) {
        return new EditDocument(value0);
    };
    return EditDocument;
})();
var EditDocuments = /* #__PURE__ */ (function () {
    function EditDocuments() {

    };
    EditDocuments.value = new EditDocuments();
    return EditDocuments;
})();
var ToggleDocumentLocks = /* #__PURE__ */ (function () {
    function ToggleDocumentLocks() {

    };
    ToggleDocumentLocks.value = new ToggleDocumentLocks();
    return ToggleDocumentLocks;
})();
var CopyDocuments = /* #__PURE__ */ (function () {
    function CopyDocuments() {

    };
    CopyDocuments.value = new CopyDocuments();
    return CopyDocuments;
})();
var DeleteDocuments = /* #__PURE__ */ (function () {
    function DeleteDocuments() {

    };
    DeleteDocuments.value = new DeleteDocuments();
    return DeleteDocuments;
})();
var ExportDocuments = /* #__PURE__ */ (function () {
    function ExportDocuments(value0) {
        this.value0 = value0;
    };
    ExportDocuments.create = function (value0) {
        return new ExportDocuments(value0);
    };
    return ExportDocuments;
})();
var RequestSignatures = /* #__PURE__ */ (function () {
    function RequestSignatures(value0) {
        this.value0 = value0;
    };
    RequestSignatures.create = function (value0) {
        return new RequestSignatures(value0);
    };
    return RequestSignatures;
})();
var UpdateForms = /* #__PURE__ */ (function () {
    function UpdateForms(value0) {
        this.value0 = value0;
    };
    UpdateForms.create = function (value0) {
        return new UpdateForms(value0);
    };
    return UpdateForms;
})();
var SearchChanged = /* #__PURE__ */ (function () {
    function SearchChanged(value0) {
        this.value0 = value0;
    };
    SearchChanged.create = function (value0) {
        return new SearchChanged(value0);
    };
    return SearchChanged;
})();
var FormPickerChanged = /* #__PURE__ */ (function () {
    function FormPickerChanged(value0) {
        this.value0 = value0;
    };
    FormPickerChanged.create = function (value0) {
        return new FormPickerChanged(value0);
    };
    return FormPickerChanged;
})();
var StartFormReorder = /* #__PURE__ */ (function () {
    function StartFormReorder() {

    };
    StartFormReorder.value = new StartFormReorder();
    return StartFormReorder;
})();
var SaveFormOrder = /* #__PURE__ */ (function () {
    function SaveFormOrder() {

    };
    SaveFormOrder.value = new SaveFormOrder();
    return SaveFormOrder;
})();
var ChangePage = /* #__PURE__ */ (function () {
    function ChangePage(value0) {
        this.value0 = value0;
    };
    ChangePage.create = function (value0) {
        return new ChangePage(value0);
    };
    return ChangePage;
})();
var CreateForms = /* #__PURE__ */ (function () {
    function CreateForms() {

    };
    CreateForms.value = new CreateForms();
    return CreateForms;
})();
var StateChanged = /* #__PURE__ */ (function () {
    function StateChanged(value0) {
        this.value0 = value0;
    };
    StateChanged.create = function (value0) {
        return new StateChanged(value0);
    };
    return StateChanged;
})();
var ViewAction = /* #__PURE__ */ (function () {
    function ViewAction(value0) {
        this.value0 = value0;
    };
    ViewAction.create = function (value0) {
        return new ViewAction(value0);
    };
    return ViewAction;
})();
var CopyStudentsSelected = /* #__PURE__ */ (function () {
    function CopyStudentsSelected(value0) {
        this.value0 = value0;
    };
    CopyStudentsSelected.create = function (value0) {
        return new CopyStudentsSelected(value0);
    };
    return CopyStudentsSelected;
})();
var DeleteConfirmed = /* #__PURE__ */ (function () {
    function DeleteConfirmed(value0) {
        this.value0 = value0;
    };
    DeleteConfirmed.create = function (value0) {
        return new DeleteConfirmed(value0);
    };
    return DeleteConfirmed;
})();
var SignatureRequestsSelected = /* #__PURE__ */ (function () {
    function SignatureRequestsSelected(value0) {
        this.value0 = value0;
    };
    SignatureRequestsSelected.create = function (value0) {
        return new SignatureRequestsSelected(value0);
    };
    return SignatureRequestsSelected;
})();
var FormsUpdateSelected = /* #__PURE__ */ (function () {
    function FormsUpdateSelected(value0) {
        this.value0 = value0;
    };
    FormsUpdateSelected.create = function (value0) {
        return new FormsUpdateSelected(value0);
    };
    return FormsUpdateSelected;
})();
var toggleLockRequests = function (state) {
    var selected = Steps_Step1_State.selectedForms(state);
    var locked = Data_Array.all(function ($157) {
        return Data_Maybe.isJust((function (v) {
            return v.locked_at;
        })($157));
    })(selected);
    var requests = (function () {
        if (locked) {
            return map(function (form) {
                return {
                    form_id: form.id,
                    locked: false
                };
            })(selected);
        };
        return map(function (form) {
            return {
                form_id: form.id,
                locked: true
            };
        })(Data_Array.filter((function () {
            var $158 = not(Data_Maybe.isJust);
            return function ($159) {
                return $158((function (v) {
                    return v.locked_at;
                })($159));
            };
        })())(selected));
    })();
    var $37 = Data_Array["null"](selected) || !Data_Array.all(function (form) {
        return form.can.lock;
    })(selected);
    if ($37) {
        return Data_Maybe.Nothing.value;
    };
    return new Data_Maybe.Just(requests);
};
var runUpdateFormsMutation = function (selection) {
    if (selection instanceof UpdateSemesterSelected) {
        return Widgets_UpdateForm.updateFormsMutation(new Data_Either.Left(selection.value0));
    };
    if (selection instanceof UpdateTeacherSelected) {
        return Widgets_UpdateForm.updateFormsMutation(new Data_Either.Right(selection.value0));
    };
    throw new Error("Failed pattern match at Steps.Step1.Update (line 144, column 36 - line 146, column 73): " + [ selection.constructor.name ]);
};
var genRFA = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new EditDocument(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return EditDocuments.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return ToggleDocumentLocks.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return CopyDocuments.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return DeleteDocuments.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new ExportDocuments(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new RequestSignatures(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new UpdateForms(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new SearchChanged(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return new FormPickerChanged(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return StartFormReorder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return SaveFormOrder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return new ChangePage(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))) {
            return CreateForms.value;
        };
        throw new Error("Failed pattern match at Steps.Step1.Update (line 107, column 1 - line 107, column 53): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof EditDocument) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof EditDocuments) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ToggleDocumentLocks) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof CopyDocuments) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof DeleteDocuments) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof ExportDocuments) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof RequestSignatures) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof UpdateForms) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof SearchChanged) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof FormPickerChanged) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
        };
        if (x instanceof StartFormReorder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof SaveFormOrder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof ChangePage) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))));
        };
        if (x instanceof CreateForms) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        throw new Error("Failed pattern match at Steps.Step1.Update (line 107, column 1 - line 107, column 53): " + [ x.constructor.name ]);
    }
};
var findExportReport = function (etype) {
    return find(function (rep) {
        return rep.label === etype.id;
    });
};
var copyRequests = function (state) {
    return function (sel) {
        var copyReqs = function (dictFunctor) {
            var map2 = Data_Functor.map(dictFunctor);
            return function (dictFoldable) {
                var fromFoldable1 = Data_Array.fromFoldable(dictFoldable);
                return function (students) {
                    return function (docId) {
                        return fromFoldable1(map2(function (s) {
                            return {
                                form_id: docId,
                                student_id: s.id
                            };
                        })(students));
                    };
                };
            };
        };
        return Data_Array.concatMap((function () {
            var $160 = copyReqs(Data_List_Types.functorList)(Data_List_Types.foldableList)(Internal_SelectionMap.listSelected(sel));
            return function ($161) {
                return $160((function (v) {
                    return v.id;
                })($161));
            };
        })())(Steps_Step1_State.selectedForms(state));
    };
};
var applyToggleLockResults = function (results) {
    return function (state) {
        var patchDoc = function (results$prime) {
            return function (form) {
                return Data_Maybe.maybe(form)(function (result) {
                    return API_Document.applyLockPermission(result)(form);
                })(find(function (result) {
                    return eq1(result.id)(form.id);
                })(results$prime));
            };
        };
        return {
            searchState: state.searchState,
            formPicker: state.formPicker,
            state: state.state,
            searchVersion: state.searchVersion,
            recentForms: map1(patchDoc(results))(state.recentForms),
            selection: fromFoldable$prime(map(patchDoc(results))(fromFoldable(Internal_SelectionMap.listSelected(state.selection))))
        };
    };
};
var applyFormsUpdateSelection = function (selection) {
    return function (state) {
        if (selection instanceof UpdateSemesterSelected) {
            return Steps_Step1_State.applySearchChanged({
                teacher: state.searchState.teacher,
                "class": state["searchState"]["class"],
                keyword: state.searchState.keyword,
                semester: Widgets_BetterSelect.setSelected(state.searchState.semester)(new Data_Maybe.Just({
                    label: selection.value0.name,
                    value: selection.value0
                }))
            })(state);
        };
        if (selection instanceof UpdateTeacherSelected) {
            return Steps_Step1_State.applySearchChanged({
                semester: state.searchState.semester,
                "class": state["searchState"]["class"],
                keyword: state.searchState.keyword,
                teacher: Widgets_BetterSelect.setSelected(state.searchState.teacher)(new Data_Maybe.Just({
                    label: selection.value0.name,
                    value: selection.value0
                }))
            })(state);
        };
        throw new Error("Failed pattern match at Steps.Step1.Update (line 133, column 45 - line 141, column 18): " + [ selection.constructor.name ]);
    };
};
export {
    StateChanged,
    ViewAction,
    CopyStudentsSelected,
    DeleteConfirmed,
    SignatureRequestsSelected,
    FormsUpdateSelected,
    UpdateSemesterSelected,
    UpdateTeacherSelected,
    EditDocument,
    EditDocuments,
    ToggleDocumentLocks,
    CopyDocuments,
    DeleteDocuments,
    ExportDocuments,
    RequestSignatures,
    UpdateForms,
    SearchChanged,
    FormPickerChanged,
    StartFormReorder,
    SaveFormOrder,
    ChangePage,
    CreateForms,
    UpdateSemester,
    UpdateTeacher,
    toggleLockRequests,
    copyRequests,
    applyFormsUpdateSelection,
    runUpdateFormsMutation,
    findExportReport,
    applyToggleLockResults,
    genRFA
};
//# sourceMappingURL=index.js.map
